(() => {
  if (customElements.get('dbsc-featured-collection')) return;

  customElements.define('dbsc-featured-collection', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-featured-track]');
      this.actions = this.querySelector('[data-featured-actions]');
      this.prev = this.querySelector('[data-featured-prev]');
      this.next = this.querySelector('[data-featured-next]');
      if (!this.track || !this.actions || !this.prev || !this.next) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.image = this.track.querySelector('.lazy-image');
      if (this.image) this.observer.observe(this.image);
      this.update();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }

    move(direction) {
      const cards = Array.from(this.track.children);
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const position = Math.abs(this.track.scrollLeft);
      const origin = cards[0]?.getBoundingClientRect();
      if (!origin) return;
      const stops = cards.map((card) => {
        const rect = card.getBoundingClientRect();
        return rtl ? origin.right - rect.right : rect.left - origin.left;
      });
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const target = direction > 0
        ? stops.find((stop) => stop > position + 2) ?? maximum
        : stops.filter((stop) => stop < position - 2).pop() ?? 0;
      this.track.scrollTo({
        left: Math.max(0, Math.min(target, maximum)) * (rtl ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }

    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.actions.hidden = maximum <= 2;
      this.prev.disabled = position <= 2;
      this.next.disabled = position >= maximum - 2;
      if (this.image) {
        const image = this.image.getBoundingClientRect();
        const carousel = this.track.parentElement.getBoundingClientRect();
        this.actions.style.setProperty('--featured-arrow-top', `${image.top - carousel.top + image.height / 2}px`);
      }
    }
  });
})();
